import React, { useEffect } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import { Toaster } from 'sonner';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ClientsSection from './components/ClientsSection';
import MissionSection from './components/MissionSection';
import WhyTurnkeySection from './components/WhyTurnkeySection';
import ProcessSection from './components/ProcessSection';
import ServicesSection from './components/ServicesSection';
import IndustriesSection from './components/IndustriesSection';
import ProjectsSection from './components/ProjectsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import './App.css';

function App() {
  // Smooth scroll behavior
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <HelmetProvider>
      <ThemeProvider>
        <Helmet>
          <html lang="en" />
          <title>Advanced Engineered Environments | Canada's Premier Cleanroom Contractor Since 1989</title>
          <meta name="description" content="Industry leaders in controlled environments and cleanroom technology. We provide turnkey cleanroom solutions for (bio)pharmaceuticals and healthcare industries. ISO 5-8 certified, cGMP compliant. 30+ years experience, 500+ projects delivered." />
          <link rel="canonical" href="https://www.aee.com/" />
        </Helmet>
        <div className="App" role="main">
          <Toaster 
            position="top-right" 
            richColors 
            toastOptions={{
              style: {
                borderRadius: 0
              }
            }}
          />
          <Header />
          <main aria-label="Main content">
            <HeroSection />
            <MissionSection />
            <ServicesSection />
            <IndustriesSection />
            <ProcessSection />
            <ProjectsSection />
            <WhyTurnkeySection />
            <ClientsSection />
            <TestimonialsSection />
            <FAQSection />
            <ContactSection />
          </main>
          <Footer />
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
